import { useCallback } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { ordersAtom } from '../atoms/ordersAtom';
import { fetchOrders } from '../services/api';

/**
 * Custom hook to read the orders state.
 * Returns the current orders or null if not loaded/error.
 */
export const useOrdersState = () => {
  const ordersData = useAtomValue(ordersAtom);
  return ordersData;
};

/**
 * Custom hook to provide actions related to orders.
 * Currently provides a function to refetch orders.
 */
export const useOrdersActions = () => {
  const setOrders = useSetAtom(ordersAtom);

  // Function to trigger a refetch of the orders
  const getOrders = useCallback(
    async (shipTo?: string) => {
      console.log(
        '[useOrders] Starting to fetch orders...',
        shipTo ? `for ship-to: ${shipTo}` : ''
      );
      try {
        const response = await fetchOrders(shipTo);
        console.log('[useOrders] Orders fetched successfully:', {
          orderCount: response.orders?.length || 0,
          orders: response.orders?.map((order) => ({
            id: order.id,
            status: order.status,
            hasTracking: !!order.trackingNumber,
            trackingNumber: order.trackingNumber,
            trackingProvider: order.trackingProvider,
            shiptoName: order.shiptoName,
          })),
        });
        setOrders(response);
      } catch (error) {
        console.error('[useOrders] Failed to fetch orders:', error);
        if (error instanceof Error) {
          console.error('[useOrders] Error details:', {
            message: error.message,
            stack: error.stack,
          });
        }
        // Clear data or set an error state on failure
        setOrders(null);
      }
    },
    [setOrders]
  );

  return {
    getOrders,
  };
};
